import React from 'react';
import styled from 'styled-components';
import { Form } from 'react-final-form';
import { flexColumn, flexSpace } from '../Flex';
import { Loader, LoaderArea } from '../Loader';
import SettingsPage from './SettingsPage';
import ActionsBar from './ActionsBar';
import LogoUpload from './LogoUpload';

const Content = styled.div`
  ${flexSpace};
  flex-wrap: wrap;
  padding-bottom: 20px;

  > div {
    width: 100%;
  }
`;

const Container = styled.form`
  ${flexColumn};
  flex: 1;
`;

const Info = ({ title, isLoading, initialValues, onSubmit, showLogo = true, children, validate }) => {
  if (isLoading) {
    return (
      <SettingsPage title={title}>
        <LoaderArea>
          <Loader />
        </LoaderArea>
      </SettingsPage>
    );
  }

  return (
    <Form
      validate={validate}
      initialValues={initialValues}
      onSubmit={onSubmit}
      render={({ handleSubmit, pristine, submitting, form }) => (
        <Container onSubmit={handleSubmit}>
          <SettingsPage title={title} scrollable>
            <Content>
              {showLogo && (
                <div className="full">
                  <LogoUpload />
                </div>
              )}

              {children}
            </Content>
          </SettingsPage>

          <ActionsBar isChanged={!pristine} submitting={submitting} form={form} />
        </Container>
      )}
    />
  );
};

export default Info;
